/** Decode an S3 object key from a URL path. Legacy AWS URLs encode spaces as `+`. */
export function decodeS3ObjectKey(rawKey) {
  if (!rawKey) return rawKey;
  const plusAsPercent20 = String(rawKey).replace(/\+/g, '%20');
  try {
    return decodeURIComponent(plusAsPercent20);
  } catch {
    return String(rawKey).replace(/\+/g, ' ');
  }
}

export function extractS3KeyFromUrl(url) {
  if (!url || typeof url !== 'string') return null;
  if (url.includes('/image-proxy?')) return null;
  if (url.startsWith('data:') || url.startsWith('blob:')) return null;
  if (!url.includes('amazonaws.com')) return null;

  try {
    const { pathname, hostname } = new URL(url);
    const rawKey = pathname.replace(/^\/+/, '');
    if (!rawKey) return null;

    const objectKey = decodeS3ObjectKey(rawKey);

    // Path-style: https://s3.eu-west-1.amazonaws.com/bucket/object-key
    if (hostname === 's3.amazonaws.com' || hostname.startsWith('s3.') || hostname.startsWith('s3-')) {
      const segments = objectKey.split('/');
      return segments.length >= 2 ? segments.slice(1).join('/') : objectKey;
    }

    // Virtual-hosted: https://bucket.s3.eu-west-1.amazonaws.com/object-key
    return objectKey;
  } catch {
    return null;
  }
}

/** Key from a proxy URL (`?key=`) or a legacy S3 URL. `+` in query means space. */
export function extractMediaKey(url) {
  if (!url || typeof url !== 'string') return null;
  if (url.includes('/image-proxy?')) {
    try {
      const query = url.includes('?') ? url.split('?').pop() : '';
      return new URLSearchParams(query).get('key');
    } catch {
      return null;
    }
  }
  return extractS3KeyFromUrl(url);
}
